export const iconFontAwesomeShoppingBagShopping = (
	<i className="fa-solid fa-bag-shopping"></i>
);
